import { Loader } from 'fukku/Loader'
import { useLabels } from 'labels/hooks/useLabels/useLabels'
import { AvatarMessage } from '../AvatarMessage/AvatarMessage'

import styles from './MessageLoader.module.scss'

interface MessageLoaderProps {
	readonly isLoading: boolean
}

export function MessageLoader({ isLoading }: MessageLoaderProps) {
	const { t } = useLabels()

	return (
		<div className={styles.messageLoader}>
			<AvatarMessage avatar='ai' />
			<Loader
				accessibilityText={{
					loaded: t('accessibility.loaded.text'),
					loading: t('accessibility.loading.text'),
				}}
				loading={isLoading}
			/>
		</div>
	)
}
